import styled, { css } from 'styled-components';
import { FlexBox, Fonts, Colors, FInter } from '@brg/ui';
import { LayoutConst } from "../../modules";
import arrowTag from './show_more.svg';

export const TagItemViewImage = styled(FlexBox)<{ image: string }>`
  background: url('${(p) => p.image}');
  background-position: center center;
  background-size: cover;
  width: 30px;
  height: 30px;
  margin-right: 8px;
  border-right: 1px solid ${Colors.geoWhite47};
`;

type TagItemViewWrapperPropsT = {
  selected?: boolean;
  disabled?: boolean;
  parent?: boolean;
  isTagOpen?: boolean;
  secondary?: boolean;
  removable?: boolean;
  educational?: boolean;
  organization?: boolean;
  variant?: string;
  isCoauthorTag?: boolean;
  isDeziiignStyle?: boolean;
  visibility?: boolean;
  opacity?: boolean;
  onlyWhiteTags?: boolean;
  isShort?: boolean;
  isProjectsTag?: boolean; // Теги на странице проекта и в загрузчике проекта
  isShowMoreTag?: boolean; 
  isInfoTags?: boolean; // Теги в попап (при наведении на таб)
  isCompetitionsTitleTag?: boolean; // Теги в конкурсах
  isCompetitionsStyleTag?: boolean;
  mobileArrowVisible?: boolean;
  selectedColor?: any;
  inactive?: boolean;
  isAcademy?: boolean;
  isGeoDafes?: boolean;
  isDvaDesign?: boolean;
  isCompetition?: boolean;
  folder?: boolean;
  isTagsCloud?: boolean;
  showRemoveIcon?: boolean;
  redBG?: boolean;
  greenBG?: boolean;
  blueBG?: boolean;
  isMobile?: boolean;
};

export const TagItemViewWrapper = styled(FlexBox)<TagItemViewWrapperPropsT>`
  position: relative;
  ${Fonts.Inter.text};
  color: ${(p) => p.theme.tags.textColor};
  // font-weight: ${p => p.parent ? "600": "400"};
  font-weight: 400;

  border: 1px solid ${(p) => p.theme.tags.borderColor};
  box-sizing: border-box;
  border-radius: ${({variant}) => variant === 'rect' ? '0' : '5px'};

  overflow: hidden;
  align-items: center;
  align-self: start;
  padding-right: 8px;

  background-color: ${(p) => p.theme.tags.extraBackgroundColor};
  user-select: none;
  // cursor: ${({organization}) => typeof organization === 'undefined' ? 'default': 'pointer'};
  cursor: pointer;

  white-space: nowrap;
  text-overflow: ellipsis;
  display: inline-block !important;
  max-width: 100%;
  ${({ isMobile, isTagsCloud, selected, isProjectsTag, isCompetition, isAcademy, isGeoDafes, theme, organization }) =>
    !isMobile &&
    css`
      &:hover {
        border: 1px solid
          ${typeof organization === 'undefined' ? 'none' : theme.tags.borderColorHover};
  
        ${isTagsCloud &&
        css`
          background: ${selected || isProjectsTag
            ? isCompetition
              ? '#0A56C4'
              : isAcademy
              ? '#879833'
              : isGeoDafes
              ? '#D24010'
              : theme.tags.cloud.selectedTagHSEHover
            : ''} !important;
        `}
      }
    `}
  
  
  &:active {
    border: 1px solid ${(p) => p.theme.tags.borderColorActive};
  }

  :after {
    content: " ";
    position: absolute;
    background: ${(p) => p.theme.tags.textColor};
    height: 1px;
    top: 15.5px;
    left: 16px;
    right: 16px;
    transition: opacity 0.2s;
    opacity: 0;
    box-sizing: border-box;
  }

  &:before {
    content: "";
    position: absolute;
    background: ${(p) => (p?.selected && p?.selectedColor?.svg?.fill) ? p?.selectedColor?.svg?.fill : p.theme.tags.textColor};
    -webkit-mask-image: url(${arrowTag});
    mask-image: url(${arrowTag});
    //background-repeat: no-repeat;
    mask-repeat: no-repeat;
    // background: url(${arrowTag}) no-repeat;
    //background-size: contain;
    mask-size: contain;
    width:14px;
    height: 14px;
    display: ${p => p.parent ? 'inline-block' : 'none' };
    top: 50%;
    transform: translateY(-50%) rotate(${p => p.isTagOpen ? "180deg" : "-90deg"}) !important;
    transition: transform 0.5s;
    right: 14px;
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      height: 12px;
      width: 12px
    }
  }

  // @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
  //   font-size: 11px;
  //   line-height: 13px;
  //   padding: 6px 12px;
  // }

  @media (max-width: 940px) {
    font-size: 13px;
    line-height: 18px;
    padding: 6px 16px;

    &:before {
      display: ${(p) => p?.mobileArrowVisible ? 'inline-block' : 'none !important'};
    }
  }

  ${(p) =>
    p.isCoauthorTag
            ? css`
    span {
      opacity: 0.47;
      color: ${(p) => p.theme.dropdown.textColor};
    }
  `
  : null}

  ${({ theme, educational, organization, isProjectsTag, isTagsCloud, onlyWhiteTags, selected, isAcademy, isShowMoreTag, isGeoDafes, isDvaDesign, isCompetition, redBG, greenBG, blueBG}) =>
        ((educational || organization) && !onlyWhiteTags)
                  ? css`
          background-color: ${(p) => selected || organization ? theme.tags.cloud.selectedTagHSE : isProjectsTag ?  theme.tags.educational.projectEdit.backgroundColor : theme.tags.educational.backgroundColor} !important;
          border: 1px solid ${({theme}) => isShowMoreTag ? Colors.galBlack47 : selected || organization ? theme.tags.cloud.selectedTagHSE : isProjectsTag ?  theme.tags.educational.projectEdit.backgroundColor : theme.tags.educational.backgroundColor} !important;
          color: ${(p) => organization ?  p.theme.tags.educational.unitColor : isProjectsTag ? theme.tags.educational.projectEdit.color : p.theme.tags.educational.color} !important;
          
          svg {
            path {
              fill: ${(p) => isProjectsTag ? theme.tags.educational.projectEdit.color : p.theme.tags.educational.color} !important;
            }
          }
          @media (hover: hover) {
               &:hover {
                border: 1px solid ${({theme}) => (selected || organization) && isCompetition && !blueBG  ? '#D40000' : (selected || organization) && isAcademy && !isProjectsTag ? '#879833'  : (selected || organization) && isDvaDesign ? 'rgba(234, 51, 35, 1)': (selected || organization) && isGeoDafes ? '#D24010' : (selected || organization) && redBG && isTagsCloud ? '#D40000' : (!selected && educational && isTagsCloud && !greenBG && !isCompetition) ? '#838382' : (selected || organization) ? theme.tags.cloud.selectedTagHSEHover : isProjectsTag ? theme.tags.educational.projectEdit.backgroundHover : theme.tags.educational.backgroundColorHover} !important;
                background-color: ${({ theme }) => (selected || organization) && isCompetition && !blueBG  ? '#D40000' : (selected || organization) && isAcademy && !isProjectsTag ? '#879833' : (selected || organization) && isDvaDesign ? 'rgba(234, 51, 35, 1)' : (selected || organization) && isGeoDafes ? '#D24010' : (selected || organization) && redBG && isTagsCloud ? '#D40000' : (!selected && educational && isTagsCloud && !greenBG && !isCompetition) ? '#2C2C2B': (selected || organization)  ? theme.tags.cloud.selectedTagHSEHover :  typeof organization === 'undefined' ? '' : ((!selected || !organization) && !theme.isDarkText) ? '#F2F2F2' : theme.tags.educational.backgroundColorHover} !important;

              }
            }
         
        `
                  : null}

  ${(p) =>
    p.selected 
      ? css`
          border-color: transparent !important;
          background-color: ${(p) => p.theme.tags.selected.backgroundColor};
          //border-color: ${(p) => p.theme.tags.selected.borderColor};
          color: ${(p) => p.theme.tags.selected.textColor} !important;
      
          svg {
            path {
              fill: {(p) => p.theme.tags.selected.textColor} !important;
            }
          }

          &:hover {
            border: 1px solid ${(p) => p.theme.tags.selected.hover.borderColor};
            background-color: ${(p) => p.theme.tags.cloud.selectedTag};
          }
        `
      : null}
  ${({theme, selected, isDeziiignStyle}) =>
    selected  && isDeziiignStyle
      ? css`
          background-color: ${(p) => p.theme.tags.cloud.selectedTag};
        `
      : null}

  ${(p) =>
    p.removable && p.selected
      ? css` 
          :after {
            background: ${(p) => p.theme.tags.textColor};
          }
          &:hover {
            :after {
              opacity: 1;
            }
            color: ${(p) => p.theme.tags.removable.selected.textColor};
            border-color: ${(p) => p.theme.tags.removable.selected.borderColor};
          }
        `
      : null}

  ${(p) =>
          p.inactive
                  ? css`
          cursor: default;

          &:hover {
            border: 1px solid ${(p) => p.theme.tags.borderColor}; !important;
          }
        `
                  : null}

  ${(p) =>
    p.disabled
      ? css`
          background-color: ${(p) => p.theme.tags.disabled.backgroundColor} !important;
          border-color: ${(p) => p.theme.tags.disabled.borderColor} !important;
          color: ${(p) => p.theme.tags.disabled.color} !important;
          cursor: default;

          :after {
            opacity: 0 !important;
            background: ${(p) => p.theme.tags.textColor}};
          }

          &:hover {
            border: 1px solid ${(p) => p.theme.tags.disabled.hover.borderColor} !important;
          }
        `
      : null}
  
  opacity: ${(p) => (p.secondary ? 0.37 : 1)};
`;

export const TagItemViewTextWrapper = styled(TagItemViewWrapper)<TagItemViewWrapperPropsT>`
  padding: ${({ parent, showRemoveIcon })=> /*folder ? '5px 16px 5px 16px' : */parent ? '6px 40px 6px 16px' : `6px ${showRemoveIcon ? '8px' : '16px'} 6px 16px`};

  ${({ folder, selectedColor }) => folder && css`
    &:hover {
      ${selectedColor}
      color: #fff !important;
    }
  `};
  ${({ selected, selectedColor }) => selected && selectedColor ? css`
    ${selectedColor}
  ` : null};

  ${({ showRemoveIcon }) => showRemoveIcon && css`
    white-space: nowrap;
    flex-flow: row;
  `};

  ${(p) => p?.isProjectsTag || p?.isInfoTags || p?.isShowMoreTag /*|| p?.parent*/ ? css`
    font-size: 15px;
    line-height: 20px;
    border: ${p?.isShowMoreTag ? '1px solid #909090' : 'none'};

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      font-size: ${p?.isShowMoreTag ? '15px' : '13px'};
      line-height: ${p?.isShowMoreTag ? '20px' : '16px'};
    }
  ` : css`
      font-size: 17px;
      line-height: 22px;

      @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
      }

  `};

  align-self: start;
  justify-content: flex-start;
  align-items: center;
  
  margin-right: 16px !important;

  margin-bottom: ${p => p?.isCompetitionsTitleTag || p?.isShowMoreTag ? "0 !important" : "12px !important"};

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: ${({isShowMoreTag}) => isShowMoreTag ? '15px' : '13px'};
    line-height: ${({isShowMoreTag}) => isShowMoreTag ? '20px' : '16px'};
    margin-bottom: ${p => p?.isCompetitionsTitleTag || p?.isShowMoreTag ? "0 !important" : "10px !important"};
  }
  
  ${(p) =>
    p.opacity
      ? css`
          opacity: 0.4;
        `
      : css`
          opacity: 1;
    `};
  
  ${(p) =>
    p.isShort
      && css`
        @media (max-width: ${LayoutConst.screen.s}px) {
          max-width: 198px;
          word-wrap: break-word;
        }
        `};

  ${(p) =>
    p.isTagOpen
      ? css`
          color: ${(p) => p.theme.tags.modal.active.activeTag} !important;
          border: 1px solid ${(p) => p.theme.tags.modal.active.border} !important;
      
          svg {
            path {
              fill: ${(p) => p.theme.tags.modal.active.activeTag} !important;
            }
          }
        `
      : null};

      ${(p) =>
        p.parent
          ? css`
          color: ${(p) => p.theme.tags.modal.notActive.tag};
          border: 1px solid ${(p) => p.theme.tags.modal.notActive.border};

              svg {
                path {
                  fill: ${(p) => p.theme.tags.modal.notActive.tag}; !important;
                }
              }

                  @media (max-width: ${LayoutConst.screen.m}px) {
                    font-weight: 600;
                    font-size: 17px;
                    line-height: 22px;
                    padding: 6px 16px;
                  }
            `
          : css`
            color: ${(p) => p.theme.tags.modal.simpleTag.color};
            border: 1px solid ${(p) => p.theme.tags.modal.notActive.border};

              svg {
                path {
                  fill: ${(p) => p.theme.tags.modal.simpleTag.color}; !important;
                }
              }


            @media (max-width: ${LayoutConst.screen.m}px) {
              font-size: ${p?.isShowMoreTag ? '11px' : p?.isProjectsTag ? '13px' : '17px'};
              line-height: ${p?.isShowMoreTag ? '13px' : p?.isProjectsTag ? '16px' : '22px'};
              margin-right: ${p?.isCompetitionsTitleTag || p?.isShowMoreTag ? "8px !important" : "16px !important"};
              margin-bottom: ${p?.isCompetitionsTitleTag || p?.isShowMoreTag ? "0px !important" : "10px !important"};
            }
            

            @media(max-width: 834px) {
              font-size: ${p?.isShowMoreTag ? '11px' : p?.isProjectsTag ? '13px' : '17px'};
              line-height: ${p?.isShowMoreTag ? '13px' : p?.isProjectsTag ? '16px' : '22px'};
              margin-right: ${p?.isCompetitionsTitleTag || p?.isShowMoreTag ? "8px !important" : "16px !important"};
              margin-bottom: ${p?.isCompetitionsTitleTag || p?.isShowMoreTag  ? "0px !important" : "10px !important"};
            }

            @media(max-width: ${LayoutConst.screen.s}px) {
              font-size: ${p?.isShowMoreTag ? '11px' : p?.isProjectsTag ? '13px' : '13px'};
              line-height: ${p?.isShowMoreTag ? '13px' : p?.isProjectsTag ? '16px' : '18px'};
            }

            @media(max-width: 567px) {
              font-size: ${p?.isShowMoreTag ? '11px' : p?.isProjectsTag ? '13px' : '13px'};
              line-height: ${p?.isShowMoreTag ? '13px' : p?.isProjectsTag ? '16px' : '18px'};
            }
        `};
`;

export const TagItemViewChildrenWrapper = styled(TagItemViewTextWrapper)<TagItemViewWrapperPropsT>`
  margin: 0 8px 8px 0;
  font-weight: 400 !important;
  align-self: start;
`;

export const TagsChildrenContainer = styled(FlexBox)<{visible?: boolean, searchBarNeeded?: boolean, isEditPage?: boolean }>`
  width: 100%;
  flex-wrap: wrap;
  display: ${(p) => p?.visible ? "flex" : "none"};
  padding-top: ${({ searchBarNeeded, isEditPage }) => searchBarNeeded ? '90px' : isEditPage ? '0px': '50px'};
  padding-bottom: 17px;
  position: relative;
`;

export const TagsSearchBar = styled(FlexBox)<{ w?: number | string, static?: boolean, isMobileInput?: boolean }>`
  width: ${p => p?.w ? `${p?.w}px` : '265px' };
  // height: 22px;
  background: ${p => p?.isMobileInput ? p?.theme.tagSearch.background : 'transparent'};
  ${p => p?.static ? css`
        position: static;
        margin-left: 0px;
  ` : css`
    position: absolute;
    top: -10px;
    left: 40px;
  `};

  place-items: baseline;
  border-bottom: 1px solid #CDCDCD;
  padding-bottom: 5px;

  input {
    color: ${Colors.galBlack47};
    font-family: 'Inter';
    font-weight: 400;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;
    padding-left: 18px;
    border: none;

    &::placeholder {
      color: ${Colors.galBlack47};
    }
  }

  svg {
    transform: rotate(0) !important;
    fill: ${Colors.galBlack47} !important;
  }
`;

export const TagMoreButton = styled(TagItemViewTextWrapper)<TagItemViewWrapperPropsT>`
  color: ${Colors.galBlack47};
  border: 1px dashed ${Colors.galBlack47};
  cursor: pointer;
  svg {
    path {
      fill: ${Colors.galBlack47};
    }
    margin-left: 10px;
  }
`;

export const TagTextWithoutSearch = styled(FInter.SmallText)`
  color: ${({ theme }) => theme.tags.modal.text.color};
  font-size: 17px;
  line-height: 22px;
  position: absolute;
  top: -10px;
  left: 40px;
  margin: 20px 0 5px 0;
`;

export const RemoveIconContainer = styled.div`
    margin-left: 8px;
    svg path {
      fill: #909090 !important;
    }
`;

import styled, { css } from 'styled-components';
import { FlexBox, Fonts, Colors, FInter } from '@brg/ui';
import { LayoutConst } from "../../modules";
import arrowTag from './show_more.svg';

export const TagItemViewImage = styled(FlexBox)<{ image: string }>`
  background: url('${(p) => p.image}');
  background-position: center center;
  background-size: cover;
  width: 30px;
  height: 30px;
  margin-right: 8px;
  border-right: 1px solid ${Colors.geoWhite47};
`;

type TagItemViewWrapperPropsT = {
  selected?: boolean;
  disabled?: boolean;
  parent?: boolean;
  isTagOpen?: boolean;
  secondary?: boolean;
  removable?: boolean;
  educational?: boolean;
  organization?: boolean;
  variant?: string;
  isCoauthorTag?: boolean;
  isDeziiignStyle?: boolean;
  visibility?: boolean;
  opacity?: boolean;
  onlyWhiteTags?: boolean;
  isShort?: boolean;
  isProjectsTag?: boolean; // Теги на странице проекта и в загрузчике проекта
  isShowMoreTag?: boolean; 
  isInfoTags?: boolean; // Теги в попап (при наведении на таб)
  isCompetitionsTitleTag?: boolean; // Теги в конкурсах
  isCompetitionsStyleTag?: boolean;
  mobileArrowVisible?: boolean;
  selectedColor?: any;
  inactive?: boolean;
  isAcademy?: boolean;
  isGeoDafes?: boolean;
  isDvaDesign?: boolean;
  isCompetition?: boolean;
  folder?: boolean;
  isTagsCloud?: boolean;
  showRemoveIcon?: boolean;
  redBG?: boolean;
  greenBG?: boolean;
  blueBG?: boolean;
  isMobile?: boolean;
};

export const TagItemViewWrapper = styled(FlexBox)<TagItemViewWrapperPropsT>`
  position: relative;
  ${Fonts.Inter.text};
  color: ${(p) => p.theme.tags.textColor};
  // font-weight: ${p => p.parent ? "600": "400"};
  font-weight: 400;

  border: 1px solid ${(p) => p.theme.tags.borderColor};
  box-sizing: border-box;
  border-radius: ${({variant}) => variant === 'rect' ? '0' : '5px'};

  overflow: hidden;
  align-items: center;
  align-self: start;
  padding-right: 8px;

  background-color: ${(p) => p.theme.tags.extraBackgroundColor};
  user-select: none;
  // cursor: ${({organization}) => typeof organization === 'undefined' ? 'default': 'pointer'};
  cursor: pointer;

  white-space: nowrap;
  text-overflow: ellipsis;
  display: inline-block !important;
  max-width: 100%;
  ${({ isMobile, isTagsCloud, selected, isProjectsTag, isCompetition, isAcademy, isGeoDafes, theme, organization }) =>
    !isMobile &&
    css`
      &:hover {
        border: 1px solid
          ${typeof organization === 'undefined' ? 'none' : theme.tags.borderColorHover};
  
        ${isTagsCloud &&
        css`
          background: ${selected || isProjectsTag
            ? isCompetition
              ? '#0A56C4'
              : isAcademy
              ? '#879833'
              : isGeoDafes
              ? '#D24010'
              : theme.tags.cloud.selectedTagHSEHover
            : ''} !important;
        `}
      }
    `}
  
  
  &:active {
    border: 1px solid ${(p) => p.theme.tags.borderColorActive};
  }

  :after {
    content: " ";
    position: absolute;
    background: ${(p) => p.theme.tags.textColor};
    height: 1px;
    top: 15.5px;
    left: 16px;
    right: 16px;
    transition: opacity 0.2s;
    opacity: 0;
    box-sizing: border-box;
  }

  &:before {
    content: "";
    position: absolute;
    background: ${(p) => (p?.selected && p?.selectedColor?.svg?.fill) ? p?.selectedColor?.svg?.fill : p.theme.tags.textColor};
    -webkit-mask-image: url(${arrowTag});
    mask-image: url(${arrowTag});
    //background-repeat: no-repeat;
    mask-repeat: no-repeat;
    // background: url(${arrowTag}) no-repeat;
    //background-size: contain;
    mask-size: contain;
    width:14px;
    height: 14px;
    display: ${p => p.parent ? 'inline-block' : 'none' };
    top: 50%;
    transform: translateY(-50%) rotate(${p => p.isTagOpen ? "180deg" : "-90deg"}) !important;
    transition: transform 0.5s;
    right: 14px;
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      height: 12px;
      width: 12px
    }
  }

  // @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
  //   font-size: 11px;
  //   line-height: 13px;
  //   padding: 6px 12px;
  // }

  @media (max-width: 940px) {
    font-size: 13px;
    line-height: 18px;
    padding: 6px 16px;

    &:before {
      display: ${(p) => p?.mobileArrowVisible ? 'inline-block' : 'none !important'};
    }
  }

  ${(p) =>
    p.isCoauthorTag
            ? css`
    span {
      opacity: 0.47;
      color: ${(p) => p.theme.dropdown.textColor};
    }
  `
  : null}

  ${({ theme, educational, organization, isProjectsTag, isTagsCloud, onlyWhiteTags, selected, isAcademy, isShowMoreTag, isGeoDafes, isDvaDesign, isCompetition, redBG, greenBG, blueBG}) =>
        ((educational || organization) && !onlyWhiteTags)
                  ? css`
          background-color: ${(p) => selected || organization ? theme.tags.cloud.selectedTagHSE : isProjectsTag ?  theme.tags.educational.projectEdit.backgroundColor : theme.tags.educational.backgroundColor} !important;
          border: 1px solid ${({theme}) => isShowMoreTag ? Colors.galBlack47 : selected || organization ? theme.tags.cloud.selectedTagHSE : isProjectsTag ?  theme.tags.educational.projectEdit.backgroundColor : theme.tags.educational.backgroundColor} !important;
          color: ${(p) => organization ?  p.theme.tags.educational.unitColor : isProjectsTag ? theme.tags.educational.projectEdit.color : p.theme.tags.educational.color} !important;
          
          svg {
            path {
              fill: ${(p) => isProjectsTag ? theme.tags.educational.projectEdit.color : p.theme.tags.educational.color} !important;
            }
          }
          @media (hover: hover) {
               &:hover {
                border: 1px solid ${({theme}) => (selected || organization) && isCompetition && !blueBG  ? '#D40000' : (selected || organization) && isAcademy && !isProjectsTag ? '#879833'  : (selected || organization) && isDvaDesign ? 'rgba(234, 51, 35, 1)': (selected || organization) && isGeoDafes ? '#D24010' : (selected || organization) && redBG && isTagsCloud ? '#D40000' : (!selected && educational && isTagsCloud && !greenBG && !isCompetition) ? '#838382' : (selected || organization) ? theme.tags.cloud.selectedTagHSEHover : isProjectsTag ? theme.tags.educational.projectEdit.backgroundHover : theme.tags.educational.backgroundColorHover} !important;
                background-color: ${({ theme }) => (selected || organization) && isCompetition && !blueBG  ? '#D40000' : (selected || organization) && isAcademy && !isProjectsTag ? '#879833' : (selected || organization) && isDvaDesign ? 'rgba(234, 51, 35, 1)' : (selected || organization) && isGeoDafes ? '#D24010' : (selected || organization) && redBG && isTagsCloud ? '#D40000' : (!selected && educational && isTagsCloud && !greenBG && !isCompetition) ? '#2C2C2B': (selected || organization)  ? theme.tags.cloud.selectedTagHSEHover :  typeof organization === 'undefined' ? '' : ((!selected || !organization) && !theme.isDarkText) ? '#F2F2F2' : theme.tags.educational.backgroundColorHover} !important;

              }
            }
         
        `
                  : null}

  ${(p) =>
    p.selected 
      ? css`
          border-color: transparent !important;
          background-color: ${(p) => p.theme.tags.selected.backgroundColor};
          //border-color: ${(p) => p.theme.tags.selected.borderColor};
          color: ${(p) => p.theme.tags.selected.textColor} !important;
      
          svg {
            path {
              fill: {(p) => p.theme.tags.selected.textColor} !important;
            }
          }

          &:hover {
            border: 1px solid ${(p) => p.theme.tags.selected.hover.borderColor};
            background-color: ${(p) => p.theme.tags.cloud.selectedTag};
          }
        `
      : null}
  ${({theme, selected, isDeziiignStyle}) =>
    selected  && isDeziiignStyle
      ? css`
          background-color: ${(p) => p.theme.tags.cloud.selectedTag};
        `
      : null}

  ${(p) =>
    p.removable && p.selected
      ? css` 
          :after {
            background: ${(p) => p.theme.tags.textColor};
          }
          &:hover {
            :after {
              opacity: 1;
            }
            color: ${(p) => p.theme.tags.removable.selected.textColor};
            border-color: ${(p) => p.theme.tags.removable.selected.borderColor};
          }
        `
      : null}

  ${(p) =>
          p.inactive
                  ? css`
          cursor: default;

          &:hover {
            border: 1px solid ${(p) => p.theme.tags.borderColor}; !important;
          }
        `
                  : null}

  ${(p) =>
    p.disabled
      ? css`
          background-color: ${(p) => p.theme.tags.disabled.backgroundColor} !important;
          border-color: ${(p) => p.theme.tags.disabled.borderColor} !important;
          color: ${(p) => p.theme.tags.disabled.color} !important;
          cursor: default;

          :after {
            opacity: 0 !important;
            background: ${(p) => p.theme.tags.textColor}};
          }

          &:hover {
            border: 1px solid ${(p) => p.theme.tags.disabled.hover.borderColor} !important;
          }
        `
      : null}
  
  opacity: ${(p) => (p.secondary ? 0.37 : 1)};
`;

export const TagItemViewTextWrapper = styled(TagItemViewWrapper)<TagItemViewWrapperPropsT>`
  padding: ${({ parent, showRemoveIcon })=> /*folder ? '5px 16px 5px 16px' : */parent ? '6px 40px 6px 16px' : `6px ${showRemoveIcon ? '8px' : '16px'} 6px 16px`};

  ${({ folder, selectedColor }) => folder && css`
    &:hover {
      ${selectedColor}
      color: #fff !important;
    }
  `};
  ${({ selected, selectedColor }) => selected && selectedColor ? css`
    ${selectedColor}
  ` : null};

  ${({ showRemoveIcon }) => showRemoveIcon && css`
    white-space: nowrap;
    flex-flow: row;
  `};

  ${(p) => p?.isProjectsTag || p?.isInfoTags || p?.isShowMoreTag /*|| p?.parent*/ ? css`
    font-size: 15px;
    line-height: 20px;
    border: ${p?.isShowMoreTag ? '1px solid #909090' : 'none'};

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      font-size: ${p?.isShowMoreTag ? '15px' : '13px'};
      line-height: ${p?.isShowMoreTag ? '20px' : '16px'};
    }
  ` : css`
      font-size: 17px;
      line-height: 22px;

      @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
      }

  `};

  align-self: start;
  justify-content: flex-start;
  align-items: center;
  
  margin-right: 16px !important;

  margin-bottom: ${p => p?.isCompetitionsTitleTag || p?.isShowMoreTag ? "0 !important" : "12px !important"};

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: ${({isShowMoreTag}) => isShowMoreTag ? '15px' : '13px'};
    line-height: ${({isShowMoreTag}) => isShowMoreTag ? '20px' : '16px'};
    margin-bottom: ${p => p?.isCompetitionsTitleTag || p?.isShowMoreTag ? "0 !important" : "10px !important"};
  }
  
  ${(p) =>
    p.opacity
      ? css`
          opacity: 0.4;
        `
      : css`
          opacity: 1;
    `};
  
  ${(p) =>
    p.isShort
      && css`
        @media (max-width: ${LayoutConst.screen.s}px) {
          max-width: 198px;
          word-wrap: break-word;
        }
        `};

  ${(p) =>
    p.isTagOpen
      ? css`
          color: ${(p) => p.theme.tags.modal.active.activeTag} !important;
          border: 1px solid ${(p) => p.theme.tags.modal.active.border} !important;
      
          svg {
            path {
              fill: ${(p) => p.theme.tags.modal.active.activeTag} !important;
            }
          }
        `
      : null};

      ${(p) =>
        p.parent
          ? css`
          color: ${(p) => p.theme.tags.modal.notActive.tag};
          border: 1px solid ${(p) => p.theme.tags.modal.notActive.border};

              svg {
                path {
                  fill: ${(p) => p.theme.tags.modal.notActive.tag}; !important;
                }
              }

                  @media (max-width: ${LayoutConst.screen.m}px) {
                    font-weight: 600;
                    font-size: 17px;
                    line-height: 22px;
                    padding: 6px 16px;
                  }
            `
          : css`
            color: ${(p) => p.theme.tags.modal.simpleTag.color};
            border: 1px solid ${(p) => p.theme.tags.modal.notActive.border};

              svg {
                path {
                  fill: ${(p) => p.theme.tags.modal.simpleTag.color}; !important;
                }
              }


            @media (max-width: ${LayoutConst.screen.m}px) {
              font-size: ${p?.isShowMoreTag ? '11px' : p?.isProjectsTag ? '13px' : '17px'};
              line-height: ${p?.isShowMoreTag ? '13px' : p?.isProjectsTag ? '16px' : '22px'};
              margin-right: ${p?.isCompetitionsTitleTag || p?.isShowMoreTag ? "8px !important" : "16px !important"};
              margin-bottom: ${p?.isCompetitionsTitleTag || p?.isShowMoreTag ? "0px !important" : "10px !important"};
            }
            

            @media(max-width: 834px) {
              font-size: ${p?.isShowMoreTag ? '11px' : p?.isProjectsTag ? '13px' : '17px'};
              line-height: ${p?.isShowMoreTag ? '13px' : p?.isProjectsTag ? '16px' : '22px'};
              margin-right: ${p?.isCompetitionsTitleTag || p?.isShowMoreTag ? "8px !important" : "16px !important"};
              margin-bottom: ${p?.isCompetitionsTitleTag || p?.isShowMoreTag  ? "0px !important" : "10px !important"};
            }

            @media(max-width: ${LayoutConst.screen.s}px) {
              font-size: ${p?.isShowMoreTag ? '11px' : p?.isProjectsTag ? '13px' : '13px'};
              line-height: ${p?.isShowMoreTag ? '13px' : p?.isProjectsTag ? '16px' : '18px'};
            }

            @media(max-width: 567px) {
              font-size: ${p?.isShowMoreTag ? '11px' : p?.isProjectsTag ? '13px' : '13px'};
              line-height: ${p?.isShowMoreTag ? '13px' : p?.isProjectsTag ? '16px' : '18px'};
            }
        `};
`;

export const TagItemViewChildrenWrapper = styled(TagItemViewTextWrapper)<TagItemViewWrapperPropsT>`
  margin: 0 8px 8px 0;
  font-weight: 400 !important;
  align-self: start;
`;

export const TagsChildrenContainer = styled(FlexBox)<{visible?: boolean, searchBarNeeded?: boolean, isEditPage?: boolean }>`
  width: 100%;
  flex-wrap: wrap;
  display: ${(p) => p?.visible ? "flex" : "none"};
  padding-top: ${({ searchBarNeeded, isEditPage }) => searchBarNeeded ? '90px' : isEditPage ? '0px': '50px'};
  padding-bottom: 17px;
  position: relative;
`;

export const TagsSearchBar = styled(FlexBox)<{ w?: number | string, static?: boolean, isMobileInput?: boolean }>`
  width: ${p => p?.w ? `${p?.w}px` : '265px' };
  // height: 22px;
  background: ${p => p?.isMobileInput ? p?.theme.tagSearch.background : 'transparent'};
  ${p => p?.static ? css`
        position: static;
        margin-left: 0px;
  ` : css`
    position: absolute;
    top: -10px;
    left: 40px;
  `};

  place-items: baseline;
  border-bottom: 1px solid #CDCDCD;
  padding-bottom: 5px;

  input {
    color: ${Colors.galBlack47};
    font-family: 'Inter';
    font-weight: 400;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;
    padding-left: 18px;
    border: none;

    &::placeholder {
      color: ${Colors.galBlack47};
    }
  }

  svg {
    transform: rotate(0) !important;
    fill: ${Colors.galBlack47} !important;
  }
`;

export const TagMoreButton = styled(TagItemViewTextWrapper)<TagItemViewWrapperPropsT>`
  color: ${Colors.galBlack47};
  border: 1px dashed ${Colors.galBlack47};
  cursor: pointer;
  svg {
    path {
      fill: ${Colors.galBlack47};
    }
    margin-left: 10px;
  }
`;

export const TagTextWithoutSearch = styled(FInter.SmallText)`
  color: ${({ theme }) => theme.tags.modal.text.color};
  font-size: 17px;
  line-height: 22px;
  position: absolute;
  top: -10px;
  left: 40px;
  margin: 20px 0 5px 0;
`;

export const RemoveIconContainer = styled.div`
    margin-left: 8px;
    svg path {
      fill: #909090 !important;
    }
`;

